var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddMoreGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.5683 24 24 18.5683 24 12C24 5.41974 18.5683 0 11.988 0C5.41974 0 0 5.41974 0 12C0 18.5683 5.4317 24 12 24ZM12 22.4447C6.20937 22.4447 1.55533 17.7787 1.55533 12C1.55533 6.20937 6.20937 1.54337 11.988 1.54337C17.7787 1.54337 22.4447 6.20937 22.4566 12C22.4566 17.7787 17.7906 22.4447 12 22.4447ZM6.78365 12.012C6.78365 12.4427 7.11864 12.7657 7.57328 12.7657H11.2223V16.4148C11.2223 16.8694 11.5454 17.1924 11.9761 17.1924C12.4427 17.1924 12.7657 16.8814 12.7657 16.4148V12.7657H16.4148C16.8694 12.7657 17.1924 12.4427 17.1924 12.012C17.1924 11.5454 16.8814 11.2223 16.4148 11.2223H12.7657V7.57328C12.7657 7.10668 12.4427 6.78365 11.9761 6.78365C11.5454 6.78365 11.2223 7.11864 11.2223 7.57328V11.2223H7.57328C7.10668 11.2223 6.78365 11.5454 6.78365 12.012Z",
    fill: "#919293"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMoreGray);
export default __webpack_public_path__ + "static/media/add-more-gray.7657c554ba6fe0d3b78523b847e634b1.svg";
export { ForwardRef as ReactComponent };